export default function Unauthorized() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-red-400 to-pink-500 text-white">
      <h1 className="text-6xl font-bold mb-4">403</h1>
      <h2 className="text-3xl font-semibold mb-6">Unauthorized Access</h2>
      <p className="mb-6">You do not have permission to view this page.</p>
      <a
        href="/login"
        className="bg-white text-red-500 px-6 py-3 rounded-full font-bold hover:bg-gray-200 transition"
      >
        Go to Login
      </a>
    </div>
  );
}
